import { Routes } from '@angular/router';

import { LoginComponent } from 'src/app/components/login/login.component';
import { NavigationComponent } from 'src/app/components/navigation/navigation.component';
import { BlogsNewsComponent } from 'src/app/components/blogs-news/blogs-news.component';
import { DevToolsComponent } from 'src/app/components/dev-tools/dev-tools.component';
import { featureFlagGuard } from 'src/app/routes/guards/feature-flag.guard';
import { environment } from 'src/environments/environment';
import { ForbiddenComponent } from 'src/app/components/forbidden/forbidden.component';

export const routes: Routes = [
	{
		path: '',
		component: NavigationComponent,
	},
	{
		path: 'login',
		component: LoginComponent,
	},
	{
		path: 'blogs-news',
		component: BlogsNewsComponent,
	},
	{
		path: 'dev-tools',
		canActivate: [featureFlagGuard(environment.flags.devTools, '/forbidden')],
		component: DevToolsComponent,
	},
	{
		path: 'forbidden',
		component: ForbiddenComponent,
	},
];
